//angular imports
import {
    ChangeDetectionStrategy,
    Component, 
    WritableSignal, 
    signal,
} from '@angular/core';

//local imports
import { PresenterType } from '@shared/components';
import { CategoryAddedMessage } from './category-added.message';

@PresenterType(
{
    model: CategoryAddedMessage
})
@Component({
    selector: 'category-added-message-template',
    templateUrl: './category-added-message-template.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CategoryAddedMessageTemplateComponent
{
    public data: WritableSignal<CategoryAddedMessage>;
    
    constructor() {
        this.data = signal<CategoryAddedMessage>(null);
    }
}